import _                from 'lodash'
import Promise          from 'bluebird'
import pluralize        from 'pluralize'
import EntityCollection from './entity_collection'
import RequestBuilder   from './request_builder'
import BackendResponse  from './backend_response'

export default class Relation
  @logRequests = false

  constructor: (@baseUrl, @route = null, @auth, @model, @associations,
                @includes = [], @orders = [],
                @pageNumber = 1, @pageSize = 1000,
                @logRequests = Relation.logRequests) ->
    @route ?= '/' + _.snakeCase(pluralize(@model.name))

  toString: ->
    "#{@constructor.name} { model: #{@model.name}, includes: #{JSON.stringify(@includes)} }"

  all: ->
    RequestBuilder.for(@).index().then(@deserializeMany.bind(@))

  where: (conditions) ->
    RequestBuilder.for(@).filteredIndex(conditions).then(@deserializeMany.bind(@))

  none: ->
    Promise.resolve(@emptyCollection())

  emptyCollection: ->
    EntityCollection.emptyFor(@model, @associations)

  collectionWith: (entities) ->
    EntityCollection.for(entities, @model, @associations)

  find: (pk) ->
    RequestBuilder.for(@).get(pk).then(@deserializeOne.bind(@))

  create: (entity) ->
    RequestBuilder.for(@).post(entity).then(@deserializeOne.bind(@))

  update: (pkOrEntity, attributes) ->
    [pk, attributes] = @_pkAndAttributesFor(pkOrEntity, attributes)

    RequestBuilder.for(@).put(pk, attributes).then(@deserializeOne.bind(@))

  partialUpdate: (pk, attributes) ->
    RequestBuilder.for(@).patch(pk, attributes).then(@deserializeOne.bind(@))

  delete: (pk) ->
    RequestBuilder.for(@).delete(pk).then -> pk

  findMany: (pkeys) ->
    Promise.mapSeries(pkeys, @find.bind(@))

  createMany: (entities) ->
    RequestBuilder.for(@).postMany(entities).then(@deserializeMany.bind(@))

  deleteMany: (pkeysOrCollection) ->
    pkeys =
      if pkeysOrCollection.constructor == EntityCollection then pkeysOrCollection.pkeys()
      else pkeysOrCollection

    Promise.mapSeries(pkeys, @delete.bind(@))

  findBy: (conditions) ->
    @page(1, 1).where(conditions).then(_.method('first'))

  # very inefficient, only for testing purposes
  deleteAll: ->
    @all().then (collection) =>
      @deleteMany(collection)

  with: (includes...) ->
    new @constructor(@baseUrl, @route, @auth, @model, @associations,
                     _.uniq(_.concat(@includes, includes)),
                     @orders, @pageNumber, @pageSize, @logRequests)

  orderBy: (orders...) ->
    new @constructor(@baseUrl, @route, @auth, @model, @associations, @includes,
                     _.uniq(_.concat(@orders, orders)),
                     @pageNumber, @pageSize, @logRequests)

  page: (pageNumber, pageSize = 20) ->
    new @constructor(@baseUrl, @route, @auth, @model, @associations,
                     @includes, @orders,
                     pageNumber, pageSize,
                     @logRequests)

  withLogging: ->
    new @constructor(@baseUrl, @route, @auth, @model, @associations, @includes, @orders,
                     @pageNumber, @pageSize, true)

  deserializeOne: (response) ->
    new BackendResponse(response, @model, @associations, @_includedModels())
      .entity()

  deserializeMany: (response) ->
    new BackendResponse(response, @model, @associations, @_includedModels(), @pageNumber, @pageSize)
      .collection()

  _includedModels: ->
    @associations.destinationModelsForPaths(@model, @includes)

  _pkAndAttributesFor: (pkOrEntity, attributes) ->
    if attributes
      pk = pkOrEntity
    else
      pk         = pkOrEntity.pk
      attributes = _.assign({}, pkOrEntity)

      delete attributes.pk

    [pk, attributes]
